import { combineEpics } from 'redux-observable';
import { onLoadOrderLifetimeRulesDoneEpic } from './_epics/onLoadOrderLifetimeRulesDoneEpic.epic';
import { onUpdateOrderLifetimeRulesDoneEpic } from './_epics/onUpdateOrderLifetimeRulesDoneEpic.epic';
import { onValidateOrderLifetimeRulesDoneEpic } from './_epics/onValidateOrderLifetimeRulesDoneEpic.epic';
import { validateOrderLifetimeRulesEpic } from './_epics/validateOrderLifetimeRules.epic';

export const controllerOrderLifetimeRulesEpic = combineEpics(
  onLoadOrderLifetimeRulesDoneEpic,
  onUpdateOrderLifetimeRulesDoneEpic,
  onValidateOrderLifetimeRulesDoneEpic,
  validateOrderLifetimeRulesEpic,
);
